export const testMapProps = {
  defaultCenter: {
    lat: 44.0,
    lng: 44.0,
  },
  defaultZoom: 5,
};
